// Remove target="_blank" from telephone links
$(document).ready(function () {
  $('a[href^="tel:"]').removeAttr("target");
});


function observeElementToHideOrSHowFooterPromo(elementToObserve) {
  const config = {
    attributes: true
  };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        const promotionFooter = document.querySelector('#promotions-container');
        if(promotionFooter) {
          if (elementToObserve.getAttribute('aria-hidden') === 'false') {
            promotionFooter.style.display = "none";
          } else {
            promotionFooter.style.display = "block";
          }
        }
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(elementToObserve, config);
}


// const mobileMenu = document.getElementById("mobile-menu");
const crossSellModal = document.querySelectorAll("div.modal[id*='modal-product-crosssale']");
// const accountPopover = document.getElementById("account-popover");
// Observe mobile menu to hide and show footer promotion
// observeElementToHideOrSHowFooterPromo(mobileMenu);
// Observe cross sell modal to hide and show footer promotion
if(crossSellModal.length){
  observeElementToHideOrSHowFooterPromo(crossSellModal[0]);
}
//Observe account Popover to hide and show footer promotion
// observeElementToHideOrSHowFooterPromo(accountPopover);

//We need to comment this function at the moment and fix it later, it considers the change location
// link as an external link as well and breaks it --- TECH-1198
 function addTargetBlank () {
  // var links = document.links;
  //   for (var i = 0, linksLength = links.length; i < linksLength; i++) {
  //     if (links[i].hostname !== window.location.hostname) {
  //       links[i].target = '_blank';
  //       links[i].rel = 'noopener';
  //       links[i].setAttribute('aria-describedby', 'a11y-new-window-message');
  //     }
  //   }
}

$(document).ready(() => {
  /* 
  Currently the prices in the Comparable comparison table are hidden by a class that makes display: none; 
  We then check if the product in the table has the no price tag and overwrite the display: none; with an 
  inline style to show it if it does not have the no price tag.
  
  This code runs everytime a node is inserted into the DOM to work with the Comparable app check if the compare-popup is reloaded, 
  if it is, the products loaded into the pop up are fetched and if they have a no price tag, the price is hidden.

  Approaches that did not work:
    - Attaching an event or listener to when the Compare button is clicked (unable to stop the a tag from default behavior and the page is 
    not fully rendered, it loads the page, but before the page is completed it builds the comparison table using the Comparable js file which 
    we don't have direct access to)
    - Altering the compare-popup on page load because the element is created dynamically everytime the a tag in the Compare button is clicked
    - Since we don't have access to the Comparable script we cannot do anything to prevent default behavior of the comparison table, we can 
    only alter it after the element has been rendered, and it can be re-rendered if the items in the Comparable cart change
  */
  function watchCompareTableChanges(records, observer) {
    let productsLoaded = [];
    for (const record of records) {
      for (const addedNode of record.addedNodes) {
        const productSummaries = record.target.parentNode.querySelectorAll('.comparable-container .product-summary');
        /* we only update the Comparable Table if there are products in the table (productSummaries) and a comparison-table is added */
        if(productSummaries.length > 0 && addedNode.classList.contains('comparison-table')) { 
          updateComparableTable (productSummaries, productsLoaded);
        } 
      }
      for (const removedNode of record.removedNodes) {
        const productSummaries = record.target.parentNode.querySelectorAll('.comparable-container .product-summary');
        /* we only update the Comparable Table if there are products in the table (productSummaries) and a product-table__cell is removed */
        if(productSummaries.length > 0 && removedNode.classList.contains('product-table__cell')) { 
          updateComparableTable (productSummaries, productsLoaded);
        } 
      }
      if (record.target.parentNode.childNodes.length === 0) {
        observer.disconnect();
      }
    }
  }
  function watchComparePopUpChanges(records, observer) {
    for (const record of records) {
      for (const addedNode of record.addedNodes) {
        const isComparePopUp = addedNode?.classList?.contains('compare-popup');
        if(isComparePopUp) {
          const comparableContent = addedNode.querySelector('.compare-popup-content')?.querySelector('[data-behavior=comparable-table-wrap]');
          if(comparableContent) {
            const compareObserver = new MutationObserver(watchCompareTableChanges);
            compareObserver.observe(comparableContent, {
              childList: true,
              subtree: true,
            });
          }
        }
      }
      if (record.target.childNodes.length === 0) {
        observer.disconnect();
      }
    }
  }
  const observer = new MutationObserver(watchComparePopUpChanges);
  observer.observe(document.body, {
    childList: true,
    subtree: false,
  });
});
